import React, { useEffect, useMemo, useState } from 'react';
import { ListGroup } from 'react-bootstrap';
import { useParams, useHistory, useLocation } from 'react-router-dom';

import useWindowSize from '../../../../hooks/useWindowSize';
import { Link } from 'react-router-dom';
import { format, isDate } from 'date-fns';
import { ReactComponent as HectorLogoFull } from 'src/assets/images/logo_new.svg';
import { getDspDetails } from 'src/views/pages/utils'
import PrimeLogo from 'src/assets/images/Prime-up-logo.png'
import InfoIcon from 'src/assets/icons/InfoIcon';
import CustomTooltip from 'src/components/Popover/CustomTooltip';

const NavLeft = ({ hideLogo = false }) => {
  const windowSize = useWindowSize();
  // const configContext = useContext(ConfigContext);
  // const { rtlLayout } = configContext.state;
  // let dropdownRightAlign = false;
  // if (rtlLayout) {
  //   dropdownRightAlign = true;
  // }

  let navItemClass = ['nav-item'];
  if (windowSize.width <= 575) {
    navItemClass = [...navItemClass, 'd-none'];
  }

  const [pageTitle, setPageTitle] = useState('');

  const getProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'))
  const loggedUser = JSON.parse(localStorage.getItem('User') || 'null') || {}
  const masterFilter = JSON.parse(sessionStorage.getItem('master-account-filters')) || {}
  const [activatedDate, setActivatedDate] = useState('')
  const isAmazon = window.location.href.indexOf('/amazon') > -1
  const isAmazonMarketingStream = window.location.href.indexOf('/amazon/marketing-stream') > -1
  const isDSPMarketingStream = window.location.href.indexOf('/amazon-dsp/marketing-stream') > -1
  const dspDetails = getProfile?.dsp ? getDspDetails(getProfile, masterFilter) : {};

  const isSQP = window.location.href.indexOf('/search-query-performance') > -1

  useEffect(() => {
    if(isAmazonMarketingStream){
      if (getProfile?.marketingStream && getProfile?.marketingStream?.datasets && Object.keys(getProfile?.marketingStream?.datasets).length > 0) {
        setActivatedDate('')
        getConsolidatedNextDay(getProfile?.marketingStream?.datasets).then((response) => {
          setActivatedDate(isDate(response) ? new Date(response) : '')
        })
      }
    } else if(isDSPMarketingStream){
      if (dspDetails?.dspId && dspDetails?.DSPMarketingStream?.[0]?.datasets && Object.keys(dspDetails?.DSPMarketingStream?.[0]?.datasets).length > 0) {
        setActivatedDate('')
        getConsolidatedNextDay(dspDetails?.DSPMarketingStream?.[0]?.datasets).then((response) => {
          setActivatedDate(isDate(response) ? new Date(response) : '')
        })
      }
    }
  }, [isAmazonMarketingStream, isDSPMarketingStream])


  const history = useHistory();
  const location = useLocation();
  const masterErrorTrackingType = location.pathname.indexOf('/dayparting') > -1
  
  useEffect(() => {
    const updateNavTitle = () => {
      if(location.pathname.indexOf('/welcome') > -1) {
        setPageTitle('Welcome back to Hector');
      } else if (
        location.pathname.indexOf('/summary/flipkart') > -1 ||
        location.pathname.indexOf('/summary/instamart') > -1 ||
        location.pathname.indexOf('/amazon/targeting') > -1 ||
        location.pathname.indexOf('/summary/myntra') > -1 ||
        location.pathname.indexOf('/summary/blinkit') > -1 ||
        location.pathname.indexOf('/summary/zepto') > -1 ||
        location.pathname.indexOf('/summary/bigbasket') > -1
      ) {
        setPageTitle('Targeting 360');
      } else if (location.pathname.includes('categorization')) {
        const isProduct = ['flipkart-categorization', 'instamart-categorization', 'myntra-categorization', 'blinkit-categorization', 'zepto-categorization', 'bigbasket-categorization'].some(
          (category) => location.pathname.includes(category)
        );
        const isTextual = location.pathname.includes('text-categorization');
        const isAsin = location.pathname.includes('categorization') && !isTextual && !isProduct;
        setPageTitle(isTextual ? 'Text Categorization' : isProduct ? 'Product Categorization' : isAsin ? 'ASIN Categorization' : '');
      }  else if (location.pathname.indexOf('amazon-automated-rules') > -1 || location.pathname.indexOf('flipkart-automated-rules') > -1) {
        const isCreatePage = window.location.href.includes('create');
        const isDetailsPage = window.location.href.includes('details');
        const isTemplatePage = window.location.href.includes('templates');
        const isTypeRule =
          location.pathname.indexOf('budget') > -1
            ? 'Budget'
            : location.pathname.indexOf('status') > -1
              ? 'Status'
              : location.pathname.indexOf('bid') > -1
                ? 'Bid'
                : location.pathname.indexOf('placement') > -1
                  ? 'Placement'
                  : location.pathname.indexOf('searchterm-negation') > -1
                    ? 'Search Term Negation'
                    : location.pathname.indexOf('searchterm-harvesting') > -1
                      ? 'Search Term Harvesting'
                      : '';
        const isViewRans = location.pathname.includes('view-logs')
        const isViewRansLogs = location.pathname.includes('details');
        const title = isCreatePage || isDetailsPage ? `Automated Rules ${isDetailsPage ? 'View' : 'Creation'} - ${isTypeRule}${isTemplatePage ? ' - Templates' : ''}` : isViewRansLogs ? `Automated Rules Detailed Logs- ${isTypeRule}` : isViewRans ? `Automated Rules Logs- ${isTypeRule}` : `Automated Rules List${isTypeRule ? ' - ' + isTypeRule : ''} ${isTemplatePage ? ' - Templates' : ''}`;
        setPageTitle(title);
      } else if (location.pathname.indexOf('/app-usage-settings') > -1) {
        setPageTitle('App Usage Tracking Settings');
      } else if (location.pathname.indexOf('/app-user-tracking') > -1) {
        setPageTitle('App Usage Tracking');
      } else if (location.pathname.indexOf('/cpc/history') > -1) {
        setPageTitle('CPC History');
      } else if (location.pathname.indexOf('/blacklist') > -1) {
        setPageTitle('Blacklist');
      } else if (location.pathname.indexOf('sponsored-ads/dashboard') > -1) {
        setPageTitle('Sponsored Ads Dashboard');
      } else if (location.pathname.indexOf('/settings') > -1) {
        setPageTitle('Settings');
      } else if (location.pathname.indexOf('/account-settings') > -1) {
        setPageTitle('Account Billing Information');
      } else if (location.pathname.toLowerCase().indexOf('/add-profile') > -1) {
        setPageTitle('Select Profile to Add');
      } else if (location.pathname.toLowerCase().indexOf('/profile') > -1) {
        setPageTitle('Profiles');
      } else if (location.pathname.toLowerCase().indexOf('user-management') > -1) {
        setPageTitle('User Management');
      } else if (location.pathname.indexOf('/admin/useraccountdetails') > -1) {
        setPageTitle('User Account Details');
      } else if (location.pathname.indexOf('snapshot') > -1) {
        setPageTitle('Snapshot');
      } else if (location.pathname.indexOf('/edit-profile') > -1) {
        setPageTitle('Edit Profile');
      } else if (location.pathname.indexOf('master-overview') > -1) {
        setPageTitle('Master Overview');
      } else if (location.pathname.indexOf('/custom/payments') > -1) {
        setPageTitle('Custom Payments');
      } else if (location.pathname.indexOf('/admin/coupon') > -1) {
        setPageTitle('Coupon Management');
      } else if (location.pathname.indexOf('/seller-sales-new') > -1) {
        setPageTitle('Seller Sales');
      } else if (location.pathname.indexOf('/admin/client-access-details') > -1) {
        setPageTitle('Client Access Details');
      } else if (location.pathname.indexOf('/admin/manual-transaction-details') > -1) {
        setPageTitle('Manual Transaction Details');
      } else if (location.pathname.indexOf('/amazon-hector-sov') > -1) {
        setPageTitle('Hector SOV');
      } else if (location.pathname.indexOf('user-activity') > -1) {
        setPageTitle('User Activity');
      } else if (location.pathname.indexOf('amazon-blacklist-keywords') > -1) {
        setPageTitle('Blacklist Keywords');
      } else if (location.pathname.indexOf('dayparting-performance') > -1) {
        setPageTitle('Hourly Performance');
      } else if (location.pathname.indexOf('master-dayparting-tracking') > -1) {
        setPageTitle('Master Dayparting Tracking');
      } else if (location.pathname.indexOf('dayparting-scheduler') > -1) {
        setPageTitle('Schedule Performance');
      } else if (location.pathname.indexOf('dayparting-history') > -1) {
        setPageTitle('Dayparting History');
      } else if (location.pathname.indexOf('dayparting-schedule-log') > -1) {
        setPageTitle('Dayparting Log');
      } else if (location.pathname.indexOf('bid-scheduler') > -1) {
        setPageTitle('Bid Scheduler');
      } else if (location.pathname.indexOf('amazon-audience-report') > -1) {
        setPageTitle('Audience Report');
      } else if (location.pathname.indexOf('amazon-create-audience') > -1) {
        setPageTitle('Create Audience');
      } else if (location.pathname.indexOf('amazon-dsp-request/create') > -1) {
        setPageTitle('Create DSP Account Request');
      } else if(location.pathname.indexOf('amazon-dsp-automated-rules') > -1) {
        const isCreatePage = window.location.href.includes('create');
        const isDetailsPage = window.location.href.includes('details');
        const isTemplatePage = window.location.href.includes('templates');
        const isTypeRule =
          location.pathname.indexOf('budget') > -1
            ? 'Budget'
            : location.pathname.indexOf('status') > -1
            ? 'Status'
            : location.pathname.indexOf('bid') > -1
            ? 'Bid'
            : location.pathname.indexOf('audience') > -1
            ? 'Audience'
            : location.pathname.indexOf('advertised-product') > -1
            ? 'Advertised Product'
            : location.pathname.indexOf('location') > -1
            ? 'Location'
            : location.pathname.indexOf('placement') > -1
            ? 'Placement'
            : location.pathname.indexOf('supplysource') > -1
            ? 'Supply Source'
            : location.pathname.indexOf('searchterm-negation') > -1
            ? 'Search Term Negation'
            : location.pathname.indexOf('searchterm-harvesting') > -1
            ? 'Search Term Harvesting'
            : '';
        const isViewRans = location.pathname.includes('view-logs')
        const isViewRansLogs = location.pathname.includes('details');
        const title = isCreatePage || isDetailsPage ? `Automated Rules ${isDetailsPage ? 'View' : 'Creation'} - ${isTypeRule}${isTemplatePage ? ' - Templates' : ''}` : isViewRansLogs ? `Automated Rules Detailed Logs- ${isTypeRule}` : isViewRans ? `Automated Rules Logs- ${isTypeRule}` : `Automated Rules List - ${isTypeRule}`;
        setPageTitle(title);
      } else if(location.pathname.indexOf('amazon-dsp-logs') > -1) {
        setPageTitle('DSP Logs');
      } else if(location.pathname.indexOf('amazon-dsp/marketing-stream') > -1) {
        setPageTitle('DSP Marketing Stream');
      } else if(location.pathname.indexOf('amazon-dsp-smart-campaigns') > -1) {
        setPageTitle('DSP Smart Campaign Manager')
      } else if(location.pathname.indexOf('amazon-dsp') > -1) {
        setPageTitle('Campaign Manager')
      } else if (location.pathname.indexOf('amazon-insights') > -1) {
        setPageTitle('Amazon Insights');
      } else if (location.pathname.indexOf('amazon-path-to-conversion') > -1) {
        setPageTitle('Path to Conversion');
      } else if (location.pathname.indexOf('amazon-history') > -1) {
        setPageTitle('Ad Account History');
      } else if (location.pathname.indexOf('/amazon/marketing-stream') > -1) {
        setPageTitle('Hourly Performance - Live');
      } else if (location.pathname.indexOf('amazon-view-audience') > -1) {
        setPageTitle('View Audience');
      } else if (location.pathname.indexOf('amazon-audience-instance-info') > -1) {
        setPageTitle('Instance Info');
      } else if (location.pathname.indexOf('amazon-audience-instance') > -1) {
        setPageTitle('Audience Instance');
      } else if (location.pathname.indexOf('amazon-custom-attribution') > -1) {
        setPageTitle('Custom Attribution');
      } else if (location.pathname.indexOf('/thankyou') > -1) {
        setPageTitle('');
      } else if (location.pathname.indexOf('/dsp-wallet') > -1) {
        setPageTitle('DSP Wallet');
      } else if (location.pathname.indexOf('/dsp-credit-top-up') > -1) {
        setPageTitle('DSP Credits Top-Up');
      } else if (location.pathname.indexOf('/dsp-payment') > -1) {
        setPageTitle('DSP Payment');
      } else if (location.pathname.indexOf('/dsp-invoice') > -1) {
        setPageTitle('DSP Invoice list');
      } else if (location.pathname.indexOf('/amazon-audience-instance/create') > -1) {
        setPageTitle('Connect Amazon Ad Account');
      } else if (location.pathname.indexOf('/billing-payments') > -1) {
        setPageTitle('Billing & Payments');
      } else if (location.pathname.indexOf('/amazon-time-to-conversion') > -1) {
        setPageTitle('Time To Conversion');
      } else if (location.pathname.indexOf('/amazon-tentpole-report') > -1) {
        setPageTitle('Tentpole Report');
      } else if (location.pathname.indexOf('/amazon-first-party-data') > -1) {
        setPageTitle('1st Party Data Set');
      } else if (location.pathname.indexOf('/amazon-first-party-demo-data') > -1) {
        setPageTitle('1st Party Demo Report');
      } else if (location.pathname.indexOf('/dsp-only-request') > -1) {
        setPageTitle('DSP Request');
      } else if (location.pathname.indexOf('/amazon/auto-campaign-bulk-list') > -1) {
        setPageTitle('Campaigns');
      } else if (location.pathname.indexOf('/amazon/auto-campaign-bulk/create') > -1) {
        setPageTitle('Auto Campaigns');
      } else if (location.pathname.indexOf('/amazon/smart-campaigns') > -1) {
        setPageTitle('Smart Campaigns');
      } else if (location.pathname.indexOf('/admin/hector-registration') > -1) {
        setPageTitle('Hector Registrations');
      } else if (location.pathname.indexOf('/amazon-dayparting-tracking') > -1) {
        setPageTitle('Dayparting Tracking');
      } else if (location.pathname.indexOf('/amazon/campaign-drafts') > -1) {
        setPageTitle('Campaign Drafts');
        if(location.pathname.indexOf('create') > -1) {
          const campaignType = location.pathname.split('/')?.[3];
          if (campaignType) {
            let formattedType ;
            if (campaignType.toLowerCase() === 'skag'){
              formattedType = 'SKAG';
            } else{
              formattedType = campaignType.charAt(0).toUpperCase() + campaignType.slice(1).toLowerCase();
            }
            setPageTitle(`Create Bulk ${String(formattedType?.replace('_', ' ')?.replace('-', ' '))} Campaign`);
          } else {
            setPageTitle('Create Bulk Campaign');
          }
        }
      } else if (location.pathname.indexOf('/manual-keyword-targeting-campaign-generation') > -1) {
        setPageTitle('Manual Keyword Targeting Campaign Generation');
      } else if (location.pathname.indexOf('/manual-product-targeting-campaign-generation') > -1) {
        setPageTitle('Manual Product Targeting Campaign Generation');
      }  else if (location.pathname.indexOf('/amazon/search-query-performance') > -1) {
        setPageTitle('Amazon Search Query Performance');
      } else if (location.pathname.indexOf('cpc-job-listing') > -1) {
        setPageTitle('Change History');
      } else if (location.pathname.indexOf('/master-error-tracking') > -1) {
        setPageTitle(masterErrorTrackingType ? 'Master Error Tracking - Dayparting' : 'Master Error Tracking - Rule Based');
      } else if (location.pathname.indexOf('/amazon-ranking-billing-payments') > -1) {
        setPageTitle('Ranking Billing & Payments');
      } else if (location.pathname.indexOf('/amazon-ranking') > -1) {
        setPageTitle('Ranking 360');
      } else if (location.pathname.indexOf('brands-dashboard') > -1) {
        setPageTitle('Brands Dashboard');
      } else {
        setPageTitle('');
      }
    };

    setTimeout(() => {
      window.scrollTo(0, 0);
      updateNavTitle();
    }, 100);

    return () => {
      setPageTitle('');
    };
  }, [location.pathname, masterErrorTrackingType]);

  const showBackButton = useMemo(() => {
    return pageTitle === 'Create Audience' ||
    pageTitle === 'View Audience' ||
    pageTitle === 'Audience Creation' ||
    pageTitle === 'Path to Conversion' || 
    pageTitle === 'Time To Conversion' ||
    pageTitle === 'Tentpole Report' || 
    String(pageTitle).includes('Automated Rules Creation') ||
    String(pageTitle).includes('Automated Rules View') ||
    String(pageTitle).includes('Automated Rules Detailed Logs') ||
    String(pageTitle).includes('Automated Rules Logs') ||
    pageTitle === 'Instance Info' ||
    pageTitle === 'Custom Attribution' ||
    pageTitle === '1st Party Demo Report' ||
    pageTitle === 'DSP Request' ||
    pageTitle === 'Create Bulk Auto Campaign' ||
    pageTitle === 'DSP Smart Campaign Manager'
  }, [pageTitle])

  const backUrl = useMemo(() => {
    if(pageTitle === 'Create Audience' || pageTitle === 'View Audience' || pageTitle === 'Audience Creation') return '/amazon-audience-report'
    if(pageTitle === 'Path to Conversion' || pageTitle == 'Custom Attribution' || pageTitle === 'Time To Conversion' || pageTitle === 'Tentpole Report') return '/amazon-insights'
    if(String(pageTitle).includes('Automated Rules Creation')) return location.pathname.replace('/create', '')
    if(String(pageTitle).includes('Automated Rules View') || String(pageTitle).includes('Automated Rules Detailed Logs')) {
        const pathname = new URL(window.location.href).pathname;
        const beforeDetails = pathname.split("/details")[0];
        return beforeDetails
    }
    if (String(pageTitle).includes('Automated Rules Logs')) {
      const pathname = new URL(window.location.href).pathname;
      const beforeDetails = pathname.split("/view-logs")[0];
      return beforeDetails
    }
    if(pageTitle === 'Instance Info') return '/amazon-audience-instance'
    if(pageTitle === '1st Party Demo Report') return '/amazon-first-party-data'
    if(pageTitle === 'DSP Request') return '/addaccount'
    if(pageTitle === 'Create Bulk Auto Campaign') return '/amazon/smart-campaigns'
    if(pageTitle === 'DSP Smart Campaign Manager') return '/amazon-dsp/campaign'
    return '/'
  }, [pageTitle])

  return (
    <React.Fragment>
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav mr-auto page-title-list h-100 d-flex align-items-center justify-content-center">
        {/* <ListGroup.Item as="li" bsPrefix=" " className={navItemClass.join(' ')}></ListGroup.Item> */}
        <ListGroup.Item
          as="li"
          bsPrefix=" "
          className={`page-header-title d-flex align-items-center ${(String(loggedUser?.email ?? '').includes('@primeup.de') || String(getProfile?.profileOwner ?? getProfile?.clientEmail ?? '').includes('@primeup.de')) ? 'pl-3' : ''} ${showBackButton ? 'nav-item d-none d-lg-flex' : 'nav-item'}`}
          style={{ lineHeight: '20px' }}
        >
          {/* <NavSearch windowWidth={windowSize.width} /> */}
          {pageTitle != '' ? (
            <>
                {(String(loggedUser?.email ?? '').includes('@primeup.de') || String(getProfile?.profileOwner ?? getProfile?.clientEmail ?? '').includes('@primeup.de')) && (
                  <img src={PrimeLogo} alt="Prime-up-logo" className="prime-logo" style={{ height: '32px', width: 'auto' }} />
                )}
              {showBackButton ? <BackButton backUrl={backUrl} pageTitle={pageTitle} /> : null}
              <div className='d-flex flex-column'>
                {!hideLogo && <h3 className="f-w-700 text-dark no-wrap page-title-responsive">{pageTitle}</h3>}
                {isAmazonMarketingStream && isSQP && activatedDate != '' ? <div className="d-flex align-items-center f-10 gap-4 no-wrap">
                  (<span className='f-w-600'>Data available from </span>
                  <span className='f-w-800'>{format(new Date(activatedDate), 'MMM dd, yyyy')}</span>)
                </div> : null}
                {isDSPMarketingStream && activatedDate != '' ? <div className="d-flex align-items-center f-10 gap-4 no-wrap">
                  (<span className='f-w-600'>Data available from </span>
                  <span className='f-w-800'>{format(new Date(activatedDate), 'MMM dd, yyyy')}</span>)
                </div> : null}
              </div>
             {pageTitle === 'Change History' && <CustomTooltip 
                title={`Change history for Targeting 360 ${isAmazon ? 'and hourly performance' : ''}`}
                >
                <span className='ml-2'>
                  <InfoIcon height={18} width={18} />
                </span>
              </CustomTooltip>}
            </>
          ) : null}
        </ListGroup.Item>
        {!hideLogo && (
          <ListGroup.Item
            as="li"
            bsPrefix=" "
            className="page-header-logo d-lg-none"
            style={{
              pointerEvents: 'none',
            }}
          >
            <HectorLogoFull width="120" />
          </ListGroup.Item>
        )}
      </ListGroup>
    </React.Fragment>
  );
};

const BackButton = ({ backUrl }) => {

  return (
    <Link
      to={backUrl}
      className="position-relative amc-left-nav cursor-pointer"
    >
      <svg
        fill="#000000"
        height="18px"
        width="18px"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 330 330"
        className='text-dark'
      >
        <path
          id="XMLID_29_"
          d="M100.606,100.606L150,51.212V315c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15V51.212l49.394,49.394  C232.322,103.535,236.161,105,240,105c3.839,0,7.678-1.465,10.606-4.394c5.858-5.857,5.858-15.355,0-21.213l-75-75  c-5.857-5.858-15.355-5.858-21.213,0l-75,75c-5.858,5.857-5.858,15.355,0,21.213C85.251,106.463,94.749,106.463,100.606,100.606z"
        />
      </svg>
    </Link>
  )
}

const getConsolidatedNextDay = async (datasets) => {
  const getNextDay = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + 1);
    return date;
  };

  const streamStartDates = Object.values(datasets).map(item => new Date(item.streamStartDate));
  const earliestStreamStartDate = new Date(Math.min(...streamStartDates));
  return getNextDay(earliestStreamStartDate)

}

export default NavLeft;
